import React from 'react'

export const ModalSubmitButtonUnstyled = ({ ...props }) => (
  <button className={props.className} onClick={props.onClick} type="submit">
    {props.label || 'Save'}
  </button>
)
